export const CRISIS_RESOURCES = {
  en: {
    title: 'If you are in crisis',
    body: 'AI PSY HELP is not emergency care and cannot keep you physically safe. If you are in immediate danger or thinking about suicide, contact local emergency services now or a local crisis line.',
    items: [
      { label: 'International Association for Suicide Prevention — local resources', href: 'https://www.iasp.info/suicidalthoughts/' },
      { label: 'IASP brief resources finder', href: 'https://www.iasp.info/suicidalthoughts/' }
    ]
  },
  uk: {
    title: 'Якщо ви в кризі',
    body: 'AI PSY HELP не є екстреною допомогою і не може гарантувати фізичну безпеку. Якщо є безпосередня небезпека або думки про самогубство — телефонуйте екстреним службам або на місцеву кризову лінію.',
    items: [
      { label: 'Лінія життя (Україна) 7333', href: 'tel:7333' },
      { label: 'Екстрена допомога 112', href: 'tel:112' },
      { label: 'IASP — локальні ресурси', href: 'https://www.iasp.info/suicidalthoughts/' }
    ]
  },
  de: {
    title: 'Wenn Sie in einer Krise sind',
    body: 'AI PSY HELP ist kein Notdienst und kann Ihre körperliche Sicherheit nicht gewährleisten. Bei akuter Gefahr oder Suizidgedanken wenden Sie sich sofort an den Notruf oder eine lokale Krisenlinie.',
    items: [
      { label: 'Telefonseelsorge 0800 111 0 111 / 0800 111 0 222', href: 'https://www.telefonseelsorge.de/' },
      { label: 'Notruf 112', href: 'tel:112' },
      { label: 'IASP — lokale Ressourcen', href: 'https://www.iasp.info/suicidalthoughts/' }
    ]
  },
  lt: {
    title: 'Jei esate krizėje',
    body: 'AI PSY HELP nėra greitoji pagalba ir negali užtikrinti fizinio saugumo. Jei gresia pavojus arba kyla minčių apie savižudybę, nedelsdami kreipkitės į greitąją pagalbą arba vietinę krizių liniją.',
    items: [
      { label: 'Jaunimo linija 8 800 28888', href: 'https://www.jaunimolinija.lt/' },
      { label: 'Pagalbos moterims linija 8 800 66366', href: 'https://www.moteriai.lt/' },
      { label: 'Skubioji pagalba 112', href: 'tel:112' }
    ]
  }
};

export function getCrisisCopy(language = 'en') {
  return CRISIS_RESOURCES[language] || CRISIS_RESOURCES.en;
}
